import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MomentModule } from 'ngx-moment';
import { ViewReceiptsComponent } from './view-receipts.component';
import { NzSpinModule } from 'ng-zorro-antd/spin';

@NgModule({
    declarations: [ViewReceiptsComponent],
    imports: [
        CommonModule,
        NzLayoutModule,
        NzMenuModule,
        NzIconModule,
        NzGridModule,
        NzButtonModule,
        FormsModule,
        MomentModule,
        ReactiveFormsModule,
        NzSpinModule
    ],
    exports: [ViewReceiptsComponent]
})
export class ViewReceiptsModule {
  static forRoot() {
    return {
        ngModule: ViewReceiptsModule,
        providers: [],
    };
 }
 }
